import { useState } from "react";
import { ArrowLeft, ArrowRight } from "react-bootstrap-icons";
import Carousel from "react-bootstrap/Carousel";

import CBTModal from "./modals/CBTModal";
import SchemaTherapyModal from "./modals/SchemaTherapyModal";
import ACTModal from "./modals/ACTModal";
import MindfulnessModal from "./modals/MindfulnessModal";
import EMDRModal from "./modals/EMDRModal";
import CFTModal from "./modals/CFTModal";

import CBTCubes from "../../assets/CBTCubes.jpg"
import schemaGroup from "../../assets/schemagroup.jpg"
import edmrWoman from "../../assets/EDMRWoman.jpg"
import mindfullnessMan from "../../assets/mindfullnessman.jpg"
import actTherapy from "../../assets/acttherapy.jpg"
import cftTherapy from "../../assets/cfttherapy.png"

const approaches = [
  {
    title: "CBT",
    sub: "Cognitive Behavioural Therapy",
    img: CBTCubes ,
  },
  {
    title: "Schema therapy",
    sub: "Depth based therapy",
    img: schemaGroup,
  },
  {
    title: "ACT",
    sub: "Acceptance based therapy",
    img: actTherapy,
  },
  {
    title: "Mindfulness",
    sub: "Mindfulness based CBT",
    img: mindfullnessMan,
  },
  {
    title: "EMDR",
    sub: "Trauma focused therapy",
    img: edmrWoman,
  },
  {
    title: "CFT",
    sub: "Compassion focused therapy",
    img: cftTherapy,
  },
];

export default function Therapies() {
  const makeSlides = (items, perSlide) => {
    const slides = [];
    for (let i = 0; i < items.length; i += perSlide) {
      slides.push(items.slice(i, i + perSlide));
    }
    return slides;
  };

  const slidesLg = makeSlides(approaches, 4);
  const slidesMd = makeSlides(approaches, 3);
  const slidesSm = makeSlides(approaches, 2);
  const slidesXs = makeSlides(approaches, 1);

  const [indexLg, setIndexLg] = useState(0);
  const [indexMd, setIndexMd] = useState(0);
  const [indexSm, setIndexSm] = useState(0);
  const [indexXs, setIndexXs] = useState(0);

  const [showCbtModal, setShowCbtModal] = useState(false);
  const [showSchemaModal, setShowSchemaModal] = useState(false);
  const [showActModal, setShowActModal] = useState(false);
  const [showMindfulnessModal, setShowMindfulnessModal] = useState(false);
  const [showEmdrModal, setShowEmdrModal] = useState(false);
  const [showCftModal, setShowCftModal] = useState(false);

  const openTherapyModal = (title) => {
    if (title === "CBT") setShowCbtModal(true);
    if (title === "Schema therapy") setShowSchemaModal(true);
    if (title === "ACT") setShowActModal(true);
    if (title === "CFT") setShowCftModal(true);
    if (title === "Mindfulness") setShowMindfulnessModal(true);
    if (title === "EMDR") setShowEmdrModal(true);
  };

  const Cards = ({ list }) => (
    <div className="row g-4 justify-content-center">
      {list.map((a) => (
        <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={a.title}>
          <button
            type="button"
            className="card h-100 bg-white bg-opacity-10 border border-white border-opacity-10 text-white rounded-4 shadow-sm overflow-hidden w-100 text-start p-0"
            onClick={() => openTherapyModal(a.title)}
          >
            <div className="ratio ratio-4x3">
              <img src={a.img} alt={a.title} className="w-100 h-100" loading="lazy" />
            </div>
            <div className="card-body p-3 text-center">
              <div className="fw-semibold">{a.title}</div>
              <div className="text-white-50">{a.sub}</div>
            </div>
          </button>
        </div>
      ))}
    </div>
  );

  const Controls = ({ count, index, setIndex }) => (
    <div className="d-flex flex-column align-items-center gap-2 mt-4">
      <div className="d-flex justify-content-center gap-3">
        <button
          className="btn therapyArrowBtn"
          onClick={() => setIndex(index === 0 ? count - 1 : index - 1)}
          type="button"
        >
          <ArrowLeft className="therapyArrowIcon" />
        </button>

        <button
          className="btn therapyArrowBtn"
          onClick={() => setIndex(index === count - 1 ? 0 : index + 1)}
          type="button"
        >
          <ArrowRight className="therapyArrowIcon" />
        </button>
      </div>

      <div className="small text-white-50 text-center">
        Press the arrows to see more therapies offered
      </div>
    </div>
  );

  return (
    <section id="therapy" className="p-5 px-5 bg-brand-orange text-white">
      <div className="row g-4">
        <div className="col-12 col-lg-3 col-xl-2">
          <h2 className="fw-semibold mb-2">Therapy Offered</h2>
          <div className="text-white-50 mb-3">Approaches and focus areas</div>
          <p className="mb-0 text-white-75">
            An integrative approach blending different therapeutic models to
            support a wide range of emotional and psychological needs.
          </p>
        </div>

        <div className="col-12 col-lg-9 col-xl-10">
          <div className="d-none d-lg-block">
            <Carousel activeIndex={indexLg} onSelect={setIndexLg} indicators={false} controls={false} interval={null}>
              {slidesLg.map((group, idx) => (
                <Carousel.Item key={idx}>
                  <Cards list={group} />
                </Carousel.Item>
              ))}
            </Carousel>
            <Controls count={slidesLg.length} index={indexLg} setIndex={setIndexLg} />
          </div>

          <div className="d-none d-md-block d-lg-none">
            <Carousel activeIndex={indexMd} onSelect={setIndexMd} indicators={false} controls={false} interval={null}>
              {slidesMd.map((group, idx) => (
                <Carousel.Item key={idx}>
                  <Cards list={group} />
                </Carousel.Item>
              ))}
            </Carousel>
            <Controls count={slidesMd.length} index={indexMd} setIndex={setIndexMd} />
          </div>

          <div className="d-none d-sm-block d-md-none">
            <Carousel activeIndex={indexSm} onSelect={setIndexSm} indicators={false} controls={false} interval={null}>
              {slidesSm.map((group, idx) => (
                <Carousel.Item key={idx}>
                  <Cards list={group} />
                </Carousel.Item>
              ))}
            </Carousel>
            <Controls count={slidesSm.length} index={indexSm} setIndex={setIndexSm} />
          </div>

          <div className="d-block d-sm-none">
            <Carousel activeIndex={indexXs} onSelect={setIndexXs} indicators={false} controls={false} interval={null}>
              {slidesXs.map((group, idx) => (
                <Carousel.Item key={idx}>
                  <Cards list={group} />
                </Carousel.Item>
              ))}
            </Carousel>
            <Controls count={slidesXs.length} index={indexXs} setIndex={setIndexXs} />
          </div>
        </div>
      </div>

      {showCbtModal && <CBTModal setShow={setShowCbtModal} />}
      {showSchemaModal && <SchemaTherapyModal setShow={setShowSchemaModal} />}
      {showActModal && <ACTModal setShow={setShowActModal} />}
      {showCftModal && <CFTModal setShow={setShowCftModal} />}
      {showMindfulnessModal && <MindfulnessModal setShow={setShowMindfulnessModal} />}
      {showEmdrModal && <EMDRModal setShow={setShowEmdrModal} />}
    </section>
  );
}
